<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="cms/blog-content/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { BlogContent } from '@/modules/cms/data/blog-content/create'
	import { BlogContentService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return BlogContent;
			},

			service()
			{
				return new BlogContentService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>